import React, { useState, useEffect, useRef } from 'react';
import { Image, Container, Row, Col } from 'react-bootstrap';
import tournamentsBanner from "../../../assets/images/tournament_highlight.png";
import tournamentsBanner1 from "../../../assets/images/tournament_highlight1.png";
// Temporarily out of rotation - re-enable when the tournament returns
// import tournamentsBanner2 from "../../../assets/images/tournament_highlight2.png";
import tournamentsBanner3 from "../../../assets/images/tournament_highlight3.png";
import tournamentsBanner4 from "../../../assets/images/tournament_highlight4.png";

const ImageFader = () => {
  const [currentImage, setCurrentImage] = useState(0);

  const imageRefs = [useRef(null), useRef(null), useRef(null), useRef(null)];
  // tournamentsBanner2 ("N3MUS weekly Tournament banner") temporarily removed from rotation
  const images = [tournamentsBanner1, tournamentsBanner, tournamentsBanner3, tournamentsBanner4];
  const altTexts = ["Chipz weekly Tournament banner", "Bonez Daily Tournament banner", "Chipz DailyTournament banner", "Chipz Hourly Tournament banner"];

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentImage(prev => (prev + 1) % images.length);
    }, 10000);

    return () => clearInterval(interval);
  }, []);

  useEffect(() => {
    // Hide all images first
    imageRefs.forEach(ref => {
      if (ref.current) {
        ref.current.style.display = 'none';
      }
    });

    // Show only the current image
    if (imageRefs[currentImage].current) {
      imageRefs[currentImage].current.style.display = 'block';
    }
  }, [currentImage]);

  const handleClick = (index) => {
    // n3mus banner is out of rotation - restore this branch with it:
    // if (index === 0) {
    //   window.open('https://hub.n3mus.com/tournaments', '_blank', 'noopener,noreferrer');
    //   return;
    // }
    setCurrentImage((prev) => (prev + 1) % images.length);
  };

  return (
    <Container>
      <Row className="justify-content-center">
        <Col className="text-center" style={{ position: 'relative', overflow: 'hidden', padding: 0 }}>
          {images.map((image, index) => (
            <div
              key={index}
              ref={imageRefs[index]}
              onClick={() => handleClick(index)}
              style={{
                width: '100%',
                height: '100%',
                display: index === 0 ? 'block' : 'none',
                cursor: 'pointer' // Make all images appear clickable
              }}
            >
              <Image
                fluid
                src={image}
                alt={altTexts[index]}
                style={{ height: '97%', width: '100%', objectFit: 'cover' }}
              />
            </div>
          ))}
        </Col>
      </Row>
    </Container>
  );
};

export default ImageFader;
